export function OutlineUpdateIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.20472 16.6627C6.00542 17.8348 7.12112 18.8135 8.49628 19.4644C12.6364 21.4226 17.5875 19.6533 19.5456 15.5132"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1207 2.99133L19.0962 7.68388L14.4037 7.65939"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.34601 8.49312C6.30428 4.34808 11.2504 2.57868 15.3904 4.54173C16.7705 5.19281 17.8813 6.17135 18.682 7.34348"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.77079 21.0155L4.79528 16.3229L9.48783 16.3474"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
